import * as React from 'react';
import { useMyConfigQuery } from '../../../services';
import { ColorModeContext } from './custom-theme-provider';

// Mounted only inside the authenticated tree. Reads the user's persisted
// dark_mode from user_config and applies it as the source of truth, overriding
// the optimistic localStorage value used for the first paint. Renders nothing.
export const DarkModeSync = () => {
    const { setMode } = React.useContext(ColorModeContext);
    const { data } = useMyConfigQuery({ fetchPolicy: 'cache-and-network' });
    const darkMode = data?.myConfig?.dark_mode;

    React.useEffect(() => {
        if (darkMode === undefined) return;
        setMode(darkMode ? 'dark' : 'light');
    }, [darkMode, setMode]);

    return null;
};
